import PasswordToggler from "src/decidim/password_toggler";
$(() => {
  const $userRegistrationForm = $("#register-form");
  const $userGroupFields = $userRegistrationForm.find(".user-group-fields");
  const userPassword = document.querySelectorAll(".user-password");
  const inputSelector = 'input[name="user[sign_up_as]"]';
  const setGroupFieldsVisibility = (value) => {
    if (value === "user") {
      $userGroupFields.hide();
    } else {
      $userGroupFields.show();
    }
  };
  setGroupFieldsVisibility($userRegistrationForm.find(`${inputSelector}:checked`).val());
  $userRegistrationForm.on("change", inputSelector, (event) => {
    const value = event.target.value;
    setGroupFieldsVisibility(value);
  });
  userPassword.forEach((element) => new PasswordToggler(element).init());
});
